/*
    Create by BaiZhiming 2015-12-16
*/
'use strict';
angular.module('singleChooseChnlModule', [])
    .controller('singleChooseChnlCtrl', ['$scope', '$timeout', '$modalInstance', '$stateParams', 'trsHttpService', 'draftParams', 'trsspliceString', 'modalDialog', 'trsGroupTreeLocationService', 'websiteLeftService', function($scope, $timeout, $modalInstance, $stateParams, trsHttpService, draftParams, trsspliceString, modalDialog, trsGroupTreeLocationService, websiteLeftService) {
        init();
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.showToggle = function(node) {
            if (node.HASCHILDREN === 'true' && node.CHILDREN.length === 0) {
                var params = {
                    'serviceid': 'mlf_mediasite',
                    'methodname': 'queryClassifyByChnl',
                    'ChannelId': node.CHANNELID,
                    'platform': draftParams.platform,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    node.CHILDREN = data.CHILDREN;
                });
            }
        };
        var promise;
        $scope.getSuggestionsSc = function(viewValue) {
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            promise = $timeout(function() {
                var searchParams = {
                    'serviceid': 'mlf_mediasite',
                    'methodname': 'queryRightClassifyByName',
                    'ChannelName': viewValue,
                    'SiteId': draftParams.siteid
                };
                if ($scope.status.isRequest) {
                    $scope.status.isRequest = false;
                    return [];
                } else {
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchParams, 'post')
                        .then(function(data) {
                            return data;
                        });
                }
            }, 100);
            return promise;
        };
        // 监控SUGGESTION
        $scope.$watch('searchChannel', function(newValue, oldValue) {
            if (angular.isObject(newValue)) {
                $scope.status.isRequest = true;
                locationChannelTree(newValue.CHANNELID);
                $scope.selectedChannel = newValue;
                $scope.searchChannel = newValue.SUGGESTION;
            }
        });

        /**
         * [isDisabled description] 根据栏目ID定位栏目树
         * @param  {[type]} node [description] 栏目ID
         * @return {[type]}           [description]
         */
        $scope.isDisabled = function(node){
            var moveArray = $scope.moveChannelIdArray;
            for (var i = 0;i < moveArray.length;i++){
                if (node.CHANNELID === moveArray[i]){
                    return true;
                }
            }
        };

        /**
         * [locationChannelTree description] 根据栏目ID定位栏目树
         * @param  {[type]} channelid [description] 栏目ID
         * @return {[type]}           [description]
         */
        function locationChannelTree(channelid) {
            var href = window.location.hash.substring(0, window.location.hash.indexOf('?')).split('/')[4];
            var platform = href === 'waitcompiled' && 1 || href === 'pending' && 2 || href === 'signed' && 3 || parseInt($stateParams.wzplatform) + 1;
            websiteLeftService.positionSelectChannel($scope.dataForTheTree, channelid, platform, $scope.expandedTest).then(function(channel) {
                $scope.selectedNode = channel;
            });
        }
        $scope.chooseChannel = function(node) {
            var moveArray = $scope.moveChannelIdArray;
            for (var i = 0;i < moveArray.length;i++){
                if (node.CHANNELID === moveArray[i]){
                    return;
                }
            }
            if (angular.isDefined($scope.selectedChannel) && $scope.selectedChannel) {
                if ($scope.selectedChannel.CHANNELID === node.CHANNELID) {
                    $scope.selectedChannel = null;
                } else {
                    $scope.selectedChannel = node;
                }
            } else {
                $scope.selectedChannel = node;
            }
        };
        $scope.cancelChannel = function(channel) {
            cannelChannel(channel);
        };
        $scope.confirm = function() {
            if (angular.isDefined($scope.selectedChannel) && $scope.selectedChannel !== null) {
                $modalInstance.close({
                    channelid: $scope.selectedChannel.CHANNELID
                });
            } else {
                modalDialog.alertType('请选择栏目', '', 'warning', false);
            }
        };

        /**
         * [init description]
         * @return  {[type]}  [return description]
         */
        function init() {
            // 弹窗标题
            $scope.modalTitle = draftParams.modalTitle;
            $scope.channelid = draftParams.channelid;
            $scope.moveChannelIdArray = draftParams.channelids.split(',');
            // 树配置开始
            $scope.treeOptions = {
                nodeChildren: 'CHILDREN',
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: 'moveDraftTree-ul',
                    li: 'moveDraftTree-li',
                    liSelected: 'a7',
                    iExpanded: 'a3',
                    iCollapsed: 'a4',
                    iLeaf: 'a5',
                    label: 'moveDraftTree-label',
                    labelSelected: 'rolegrouplabselected'
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN === 'false';
                }
            };
            // 树配置结束
            var params = {
                'serviceid': 'mlf_mediasite',
                'methodname': 'queryClassifyBySite',
                'SiteId': draftParams.siteid,
                'platform': draftParams.platform,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.SITEDESC = data.SITEDESC;
                $scope.dataForTheTree = data.CHILDREN;
                // getChannelDescById($scope.channelid);
                // locationChannelTree($scope.channelid);
            });
            $scope.status = {
                ifExpand: true
            };            
        }

        /**
         * [getChannelDescById description] 通过栏目ID获取栏目名
         * @param  {[type]} channelid [description] 栏目ID
         * @return {[type]}           [description]
         */
        function getChannelDescById(channelid) {
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'getChannelIdPath',
                ChannelId: channelid,
                Burster: ','
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.selectedChannel = {
                    CHANNELID: channelid,
                    CHNLDESC: data[data.length - 1].CHANNELPATH
                };
            });
        }
        $scope.isChecked = function(node) {
            if (angular.isDefined($scope.selectedChannel)) {
                var flag = false;
                if ($scope.selectedChannel.CHANNELID === node.CHANNELID) {
                    flag = true;
                }
                return flag;
            }
        };

        /**
         * [cannelChannel description]
         * @return  {[type]}  [return description]
         */
        function cannelChannel() {
            $scope.selectedChannel = null;
        }
    }]);
